import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || '';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  if (!token) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: 'var(--color-bg-content)' }}>
        <div className="card shadow-sm p-4 text-center" style={{ maxWidth: 420 }}>
          <i className="bi bi-exclamation-triangle text-warning fs-1 mb-3" />
          <p className="text-muted">Kein gültiger Reset-Token gefunden.</p>
          <Link to="/forgot-password" className="btn btn-primary mt-2">Neuen Link anfordern</Link>
        </div>
      </div>
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (password !== passwordConfirm) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }
    if (password.length < 8) {
      setError('Das Passwort muss mindestens 8 Zeichen lang sein.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
        cache: 'no-store',
      });
      const body = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
      if (!res.ok) throw new Error(body.detail || `HTTP ${res.status}`);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="card shadow-sm" style={{ width: '100%', maxWidth: 420 }}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <i className="bi bi-lightning-charge-fill text-warning fs-1" />
            <h4 className="mt-2 fw-bold">MK Workout</h4>
            <p className="text-muted small">Neues Passwort vergeben</p>
          </div>

          {done ? (
            <div className="text-center">
              <div className="alert alert-success">
                <i className="bi bi-check-circle me-2" />
                Passwort erfolgreich geändert!
              </div>
              <Link to="/login" className="btn btn-primary mt-2">
                <i className="bi bi-box-arrow-in-right me-1" />
                Jetzt anmelden
              </Link>
            </div>
          ) : (
            <>
              {error && <div className="alert alert-danger py-2 small">{error}</div>}
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Neues Passwort</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoFocus
                    minLength={8}
                    placeholder="Mindestens 8 Zeichen"
                  />
                </div>
                <div className="mb-4">
                  <label className="form-label">Passwort bestätigen</label>
                  <input
                    type="password"
                    className="form-control"
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    required
                    placeholder="Passwort wiederholen"
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? (
                    <><span className="spinner-border spinner-border-sm me-2" />Speichern…</>
                  ) : (
                    <><i className="bi bi-lock me-1" />Passwort speichern</>
                  )}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
